export enum TEAMS_ACTIONS {
  getAccountTeams = 'teams/getAccountTeams',
  assignUserGroupToTeam = 'teams/assignUserGroupToTeam'
}
